module.exports = {
    none: 'none', // processing is not started yet, because it is a draft or it is scheduled for future
    started: 'started', // not sure what this status means
    sending: 'sending', // campaign messages are being sent
    monitoring: 'monitoring', // all messages are sent, system monitoring delivery statuses
    invoicing: 'invoicing', // all messages are in final states (delivered or failed), system is creating invoice
    complete: 'complete', // campaign is fully processed
};
